import { StringValue } from '@coveo/bueno';
import { createAction } from '@reduxjs/toolkit';
import { validatePayload } from '../../utils/validate-payload.js';
const optionalAndPossiblyEmpty = () => new StringValue({ required: false, emptyAllowed: true });
export const updateAdvancedSearchQueries = createAction('advancedSearchQueries/update', (payload) => validatePayload(payload, {
    aq: optionalAndPossiblyEmpty(),
    cq: optionalAndPossiblyEmpty(),
    lq: optionalAndPossiblyEmpty(),
    dq: optionalAndPossiblyEmpty(),
}));
export const registerAdvancedSearchQueries = createAction('advancedSearchQueries/register', (payload) => validatePayload(payload, {
    aq: optionalAndPossiblyEmpty(),
    cq: optionalAndPossiblyEmpty(),
    lq: optionalAndPossiblyEmpty(),
    dq: optionalAndPossiblyEmpty(),
}));
